export const defaultColumnWidth = 15;
export const totalPriceColumnWidth = 30;
export const nameColumnWidth = 80;
export const lastColumnWidth = 20;
